import { render, staticRenderFns } from "./codegen_shell.vue?vue&type=template&id=66d9b187&scoped=true"
import script from "./codegen_shell.vue?vue&type=script&lang=js"
export * from "./codegen_shell.vue?vue&type=script&lang=js"
import style0 from "./codegen_shell.vue?vue&type=style&index=0&id=66d9b187&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d9b187",
  null
  
)

export default component.exports